import React from 'react';
import PropTypes from 'prop-types';
import { Segment } from 'semantic-ui-react';
import {
  FormattedMessage,
  useIntl,
  injectIntl,
  defineMessages,
} from 'react-intl';
import {
  CheckboxWidget,
  ObjectListWidget,
  TextWidget,
  ObjectBrowserWidget,
} from '@plone/volto/components';
import { ColorListWidget } from '@package/components/Widgets';

const messages = defineMessages({
  fullWidth: {
    id: 'fullWidth',
    defaultMessage: 'Full width',
  },
  transparent: {
    id: 'transparent',
    defaultMessage: 'Transparent',
  },
  primaryLightColor: {
    id: 'primaryLightColor',
    defaultMessage: 'Primary light',
  },
  secondaryColor: {
    id: 'secondaryColor',
    defaultMessage: 'Secondary',
  },
  backgroundColor: {
    id: 'backgroundColor',
    defaultMessage: 'Background color',
  },
  column: {
    id: 'column',
    defaultMessage: 'Column',
  },
  addColumn: {
    id: 'addColumn',
    defaultMessage: 'Add column',
  },
  icon: {
    id: 'icon',
    defaultMessage: 'Icon',
  },
  imageDescription: {
    id: 'imageDescription',
    defaultMessage:
      'The image must be a PNG or SVG. The maximum recommended size for PNG is 200x200px.',
  },
  linkMore: {
    id: 'linkMore',
    defaultMessage: 'Link more',
  },
  linkMoreTitle: {
    id: 'linkMoreTitle',
    defaultMessage: 'Title of link more',
  },
});

const Sidebar = (props) => {
  const { data, onChangeBlock, block } = props;
  const intl = useIntl();

  return (
    <Segment.Group raised>
      <header className="header pulled">
        <h2>
          <FormattedMessage
            id="IconsAndNumbersBlock"
            defaultMessage="Blocco di icone o numeri"
          />
          :
        </h2>
      </header>
      <Segment className="form">
        <CheckboxWidget
          id="fullWidth"
          title={intl.formatMessage(messages.fullWidth)}
          value={data.fullWidth ? data.fullWidth : false}
          onChange={(name, value) => {
            onChangeBlock(block, { ...data, [name]: value });
          }}
        />
        <ColorListWidget
          id="background_color"
          title={intl.formatMessage(messages.backgroundColor)}
          colors={[
            {
              name: 'transparent',
              label: intl.formatMessage(messages.transparent),
            },
            {
              name: 'secondary',
              label: intl.formatMessage(messages.secondaryColor),
            },
            {
              name: 'primary-light',
              label: intl.formatMessage(messages.primaryLightColor),
            },
          ]}
          value={data.background_color ?? 'trasparent'}
          onChange={(name, value) =>
            onChangeBlock(block, { ...data, [name]: value })
          }
        />
        <div className="fixed-object-list">
          <ObjectListWidget
            {...props}
            id="columns"
            value={data?.columns ?? []}
            onChange={(id, value) =>
              props.onChangeBlock(block, { ...data, [id]: value })
            }
            schema={() => {
              const columnsSchema = {
                title: intl.formatMessage(messages.column),
                addMessage: intl.formatMessage(messages.addColumn),
                fieldsets: [
                  {
                    id: 'default',
                    title: 'Default',
                    // fields: ['icon'],
                    fields: ['iconImage'],
                  },
                ],
                properties: {
                  // icon: {
                  //   title: 'Icona',
                  //   type: 'fontawesome_icon',
                  // },
                  iconImage: {
                    title: intl.formatMessage(messages.icon),
                    description: intl.formatMessage(messages.imageDescription),
                    widget: 'image_upload_widget',
                    openObjectBrowser: props.openObjectBrowser,
                  },
                },

                required: [],
              };

              return columnsSchema;
            }}
          />
        </div>

        <ObjectBrowserWidget
          id="href"
          title={intl.formatMessage(messages.linkMore)}
          mode="link"
          allowExternals={true}
          value={data.href}
          widgetOptions={{
            pattern_options: { maximumSelectionSize: 1 },
          }}
          onChange={(name, value) => {
            onChangeBlock(block, {
              ...data,
              href: value,
            });
          }}
        />
        <TextWidget
          id="href_title"
          title={intl.formatMessage(messages.linkMoreTitle)}
          value={data.href_title ?? ''}
          onChange={(name, value) => {
            onChangeBlock(block, { ...data, [name]: value });
          }}
        />
      </Segment>
    </Segment.Group>
  );
};

Sidebar.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  block: PropTypes.string.isRequired,
  onChangeBlock: PropTypes.func.isRequired,
  openObjectBrowser: PropTypes.func.isRequired,
};

export default injectIntl(Sidebar);
